import React from 'react';
import { Link } from 'react-router-dom';

import styles from './ContentTags.scss';

function ContentTags({ gradeRange, tags, size }) {
  if (!gradeRange || !tags) {
    return null;
  }
  const gradeTags = [];
  let lower = parseInt(gradeRange && gradeRange.lower, 10);
  const higher = parseInt(gradeRange && gradeRange.higher, 10);

  if (lower === -1) lower = 0;
  for (let i = lower; i <= higher; i++) {
    gradeTags.push({
      id: i === 0 ? 'pre-k' : i,
      text: i === 0 ? 'Pre-K & K' : `Grade ${i}`,
      to: i === 0 ? '/pre-k-and-k-playground' : `/grade/${i}`,
    });
  }
  const sizeClass =
    size && size === 'half'
      ? `ContentTags--half-size`
      : `ContentTags--full-size`;
  return (
    <div className={`ContentTags ${sizeClass}`}>
      <header className="ContentTags__header">
        <h4 className="ContentTags__headline">Tags</h4>
      </header>
      <div className="ContentTags__list">
        {gradeTags.map((tag, i) => (
          <Link
            to={tag.to}
            className={`ContentTags__tag ContentTags__tag--grade-${tag.id}`}
            key={`gradeTag-${tag.id}`}
          >
            {tag.text}
          </Link>
        ))}
        {tags.map((tag, i) => (
          <div className="ContentTags__tag" key={`tag-${i}`}>
            {tag}
          </div>
        ))}
      </div>
    </div>
  );
}

export default ContentTags;
